/**
 * dbt Integration Configuration
 * Configuration settings for dbt Core and Cloud integration
 */

export const dbtConfig = {
  // API endpoints
  endpoints: {
    connections: '/dbt/connections',
    projects: '/dbt/projects',
    health: '/dbt/health',
    validateArtifacts: '/dbt/validate-artifacts'
  },

  // Polling configuration
  polling: {
    interval: 30000, // 30 seconds
    maxRetries: 3
  },

  // UI configuration
  ui: {
    pageSize: 25,
    maxLineageNodes: 100,
    chartRefreshInterval: 60000, // 1 minute
    defaultLimit: 10
  },

  // Connection types
  connectionTypes: {
    CORE: 'core',
    CLOUD: 'cloud'
  },

  // Validation statuses
  validationStatus: {
    PENDING: 'pending',
    VALID: 'valid',
    INVALID: 'invalid'
  },

  // Model materializations
  materializations: [
    { value: 'table', label: 'Table' },
    { value: 'view', label: 'View' },
    { value: 'incremental', label: 'Incremental' },
    { value: 'ephemeral', label: 'Ephemeral' }
  ],

  // Test types
  testTypes: [
    { value: 'generic', label: 'Generic' },
    { value: 'singular', label: 'Singular' },
    { value: 'custom', label: 'Custom' }
  ],

  // Run statuses
  runStatus: {
    SUCCESS: 'success',
    ERROR: 'error',
    RUNNING: 'running',
    CANCELLED: 'cancelled',
    SKIPPED: 'skipped'
  },

  // Status badge variants for DaisyUI
  statusBadgeVariants: {
    valid: 'badge-success',
    invalid: 'badge-error',
    pending: 'badge-warning',
    success: 'badge-success',
    error: 'badge-error',
    running: 'badge-info',
    cancelled: 'badge-ghost',
    skipped: 'badge-ghost'
  },

  // Colors for charts and visualizations
  colors: {
    model: '#3b82f6',    // blue
    source: '#10b981',   // green
    test: '#f59e0b',     // amber
    seed: '#8b5cf6',     // purple
    snapshot: '#ec4899'  // pink
  }
};

export default dbtConfig;
